import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  @media (max-width: ${({ theme }) => theme.media.md}) {
    flex-direction: column;
  }
`;
export const Sidebar = styled.div`
  width: 270px;
  margin-inline-start: ${({ theme }) => theme.spacing.x4};
  flex-shrink: 0;
  @media (max-width: ${({ theme }) => theme.media.md}) {
    order: 1;
    margin-inline-start: 0px;
    width: 100%;
  }
`;
export const Main = styled.div`
  flex-grow: 1;
  @media (max-width: ${({ theme }) => theme.media.md}) {
    order: 2;
    margin-top: ${({ theme }) => theme.spacing.x4};
  }
`;
